import { slateGroupScopes } from '../constants/odds';
import { SlateGroupScope } from '../enums/slate-group-scope.enum';

export interface SlateScopeLabels {
	singular: string;
	plural: string;
	adjective: string;
	leaderboardTitle: string | null;
}

const SLATE_SCOPE_LABELS: Partial<Record<SlateGroupScope, SlateScopeLabels>> = {
	[SlateGroupScope.BY_WEEK]: {
		singular: 'Week',
		plural: 'Weeks',
		adjective: 'Weekly',
		leaderboardTitle: null,
	},
	[SlateGroupScope.BY_MONTH]: {
		singular: 'Month',
		plural: 'Months',
		adjective: 'Monthly',
		leaderboardTitle: 'Monthly Leaderboard',
	},
};

const DEFAULT_SLATE_SCOPE_LABELS: SlateScopeLabels = {
	singular: 'Slate',
	plural: 'Slates',
	adjective: 'Slate',
	leaderboardTitle: null,
};

export const getSlateScopeLabels = (categoryId?: string | null): SlateScopeLabels => {
	const scope = categoryId ? slateGroupScopes[categoryId] : undefined;
	return (scope && SLATE_SCOPE_LABELS[scope]) || DEFAULT_SLATE_SCOPE_LABELS;
};

export const isSlateFilterEligibleCategory = (categoryId?: string | null): boolean => {
	const scope = categoryId ? slateGroupScopes[categoryId] : undefined;
	return scope === SlateGroupScope.BY_WEEK || scope === SlateGroupScope.BY_MONTH;
};
